
    import {Component, Vue} from 'vue-property-decorator'
    import {
        CompanyInfoDto,
        deleteMerchants,
        getCompanyDtl,
        getMerchantExInfo,
        getMerchantsDtl, MerchantExInfoDto,
    } from "@/api/customerManage";
    import {Getter,Action} from "vuex-class";
    import {isPermitEnterShop} from "@/api/shoppingMall";

    @Component({
        name: 'ClientDetail'
    })
    export default class ClientDetail extends Vue {
        @Getter companyId!: string
        @Action setProviderId!: (val: string) => void;
        relationId = ''
        merchantsId = ''
        companyInfo: CompanyInfoDto | Record<string, any> = {}
        serviceLineActive = ['1']
        addressActive = ['1']
        accountActive = ['1']
        invoiceActive = ['1']
        isAddPage = true // 是否是添加客户进入的详情页
        merchantExInfo: MerchantExInfoDto = {}

        created () {
            this.relationId = this.$route.query.relationId as string
            this.merchantsId = this.$route.query.merchantsId as string
            this.isAddPage = this.$route.query.fromPage === 'add'
            this.getInfo()
        }

        toSetting () {
          // 删除按钮权限
          // if (!this.$action('edit')) {
          //   return false
          // }
            this.$router.push({
                path: '/customerSetting',
                query: {
                    relationId: this.relationId,
                    merchantsId: this.merchantsId
                }
            })
        }

        /**
         * 跳转到店铺首页
         * @param
         */
        toShopHome() {
           // 删除按钮权限
          // if(!this.$action('shopHome')){
          //   return false
          // }
            const obj = {
                shopId: this.merchantsId,
                customerId: this.companyId
            }
            isPermitEnterShop(obj).then((res) => {
                if (res.code === '000000') {
                    this.setProviderId(this.merchantsId)
                    this.$router.push({ path: '/storeHome', query: { shopHomeTitle: this.companyInfo.companyName } })
                }else if(res.code === '000002'){
                  this.$toast(res.msg)
                }
            })

        }


        getInfo () {
            getCompanyDtl({ companyId: this.merchantsId }, false).then(res => {
                this.companyInfo = res.data || {}
            })

            const obj = {
                companyId: this.companyId,
                merchantId: this.merchantsId,
                dataViewType: 1
            }
            getMerchantExInfo(obj).then((res) => {
                this.merchantExInfo = res.data
            })
        }

        delData() {
           // 删除按钮权限
          // if(!this.$action('delete')){
          //   return false
          // }
          this.$confirmDialog.show({
            okText: "确认",
            cancelText: "取消",
            tips: "确定删除吗？",
            onOk: () => {
              return this.delFunc()
            },
          });
        }

        delFunc() {
          const params = {
            companyId: this.companyId,
            merchantsId: this.merchantsId
          }
          deleteMerchants(params).then((res) => {
            this.$toast.success({
              message: '删除成功',
              duration: 1000,
              onClose: () => {
                // this.$router.push({
                //   path: '/customerManage',
                // })
                this.$router.back()
              }
            })
          }).catch(() => {
          })
        }

        /**
         * 获取客户设置详情
         */
        getSettingInfo() {
            getMerchantsDtl({relationId: this.relationId}).then(res => {
                const data = res.data || {}
                this.toPlaceOrder(data)
            })
        }

        toPlaceOrder (data) {
            this.$router.push({
                path: '/valetOrder',
                query: {
                    customerId: data.merchantsId,
                    customerName: data.merchantsName,
                    customerLever: data.levelId,
                    customerLeverName: data.levelName
                }
            })
        }

    }
